import { render } from "./Organize.vue?vue&type=template&id=2a886311"
import script from "./Organize.vue?vue&type=script&lang=js"
export * from "./Organize.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__